import { computed, defineComponent } from 'vue';
export default defineComponent({
    name: 'SlideShowBottomBar',
    props: {
        isGridView: { type: Boolean },
        isLightboxView: { type: Boolean },
        currentSlide: { type: Number, default: 0 },
        slides: { type: Number, default: 1 },
        gridSlides: { type: Number, default: 1 },
        isSticky: { type: Boolean },
        blockWidthClass: { type: String, default: '' },
        route: { type: Object, default: () => ({}) },
        isSmallScreen: { type: Boolean },
    },
    emits: ['slide', 'toggle-grid-view'],
    setup(props) {
        const numOfSlides = computed(() => {
            if (props.isGridView) {
                return props.gridSlides;
            }
            return props.slides;
        });
        return {
            numOfSlides,
        };
    },
});
